//only execute slider code if page has one
if(document.querySelector(".ba-container") != null)
{
  var sWidth = $(".ba-container").width();
  var bHeight = sWidth * .667;
  let thumb = document.getElementsByClassName("ba-slider")[0];
  $('.ba-container .ba-img').css('backgroundSize', sWidth + "px 100%" );
  $('.ba-container').css('height', bHeight + "px");

  thumb.style.setProperty("--dynamic-height", bHeight + "px");

  $(window).on('resize', function(){
    sWidth = $(".ba-container").width();
    bHeight = sWidth * .667;
    $('.ba-container .ba-img').css('backgroundSize', sWidth + "px 100%" );
    $('.ba-container').css('height', bHeight + "px");
    thumb.style.setProperty("--dynamic-height", bHeight + "px");
  });


  $("#ba-slider").on("input change", (e)=>{
    const sliderPos = e.target.value;
    // Update the width of the foreground image
    $('.ba-foreground-img').css('width', `${sliderPos}%`)
    // Update the position of the slider button
    $('.ba-slider-button').css('left', `calc(${sliderPos}% - 18px)`)
  });
} else {

}
